import _extends from '@babel/runtime/helpers/extends';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { createElement, PureComponent, Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BigFileIcon, { defaultStyles } from 'react-file-icon';
import { faFileWord, faFileExcel, faFilePowerpoint, faFileArchive, faFileCode, faFileAudio, faFileVideo, faFileImage, faFilePdf, faFileAlt, faFile } from '@fortawesome/free-regular-svg-icons';
import _typeof from '@babel/runtime/helpers/typeof';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import Dropzone from 'react-dropzone';

// Partially based on:
// https://stackoverflow.com/a/4212908/2570866
var wordMimeTypes = [// Microsoft Word
// .doc .dot
'application/msword', // .doc .dot
'application/msword-template', // .docx
'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .dotx (no test)
'application/vnd.openxmlformats-officedocument.wordprocessingml.template', // .docm
'application/vnd.ms-word.document.macroEnabled.12', // .dotm (no test)
'application/vnd.ms-word.template.macroEnabled.12', // LibreOffice/OpenOffice Writer
// .odt
'application/vnd.oasis.opendocument.text', // .ott
'application/vnd.oasis.opendocument.text-template', // .fodt
'application/vnd.oasis.opendocument.text-flat-xml'];
var excelMimeTypes = [// .csv
'text/csv', // TODO: maybe more data files
// Microsoft Excel
// .xls .xlt .xla (no test for .xla)
'application/vnd.ms-excel', // .xlsx
'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xltx (no test)
'application/vnd.openxmlformats-officedocument.spreadsheetml.template', // .xlsm
'application/vnd.ms-excel.sheet.macroEnabled.12', // .xltm (no test)
'application/vnd.ms-excel.template.macroEnabled.12', // .xlam (no test)
'application/vnd.ms-excel.addin.macroEnabled.12', // .xlsb (no test)
'application/vnd.ms-excel.addin.macroEnabled.12', // LibreOffice/OpenOffice Calc
// .ods
'application/vnd.oasis.opendocument.spreadsheet', // .ots
'application/vnd.oasis.opendocument.spreadsheet-template', // .fods
'application/vnd.oasis.opendocument.spreadsheet-flat-xml'];
var powerpointMimeTypes = [// Microsoft Word
// .ppt .pot .pps .ppa (no test for .ppa)
'application/vnd.ms-powerpoint', // .pptx
'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .potx (no test)
'application/vnd.openxmlformats-officedocument.presentationml.template', // .ppsx
'application/vnd.openxmlformats-officedocument.presentationml.slideshow', // .ppam
'application/vnd.ms-powerpoint.addin.macroEnabled.12', // .pptm
'application/vnd.ms-powerpoint.presentation.macroEnabled.12', // .potm
'application/vnd.ms-powerpoint.template.macroEnabled.12', // .ppsm
'application/vnd.ms-powerpoint.slideshow.macroEnabled.12', // LibreOffice/OpenOffice Writer
// .odp
'application/vnd.oasis.opendocument.presentation', // .otp
'application/vnd.oasis.opendocument.presentation-template', // .fodp
'application/vnd.oasis.opendocument.presentation-flat-xml'];
var archiveFileTypes = [// .zip
'application/zip', // .z7
'application/x-7z-compressed', // .ar
'application/x-archive', // .tar
'application/x-tar', // .tar.gz
'application/gzip', // .tar.Z
'application/x-compress', // .tar.bz2
'application/x-bzip', // .tar.lz
'application/x-lzip', // .tar.lz4
'application/x-lz4', // .tar.lzma
'application/x-lzma', // .tar.lzo (no test)
'application/x-lzop', // .tar.xz
'application/x-xz', // .war
'application/x-webarchive', // .rar
'application/vnd.rar'];
var codeFileTypes = [// .html .htm
'text/html', // .css
'text/css', // .js
'application/x-javascript', // .json
'application/json', // .py
'text/x-python', // .go
'text/x-go', // .c
'text/x-csrc', // .cpp
'text/x-c++src', // .rb
'application/x-ruby', // .rust
'text/rust', // .java
'text/x-java', // .php
'application/x-php', // .cs
'text/x-csharp', // .scala
'text/x-scala', // .erl
'text/x-erlang', // .sh
'application/x-shellscript'];
var mimeTypeToIconMap = {
  'application/pdf': faFilePdf
};
var mimeTypeToFallBackStyle = {
  'application/pdf': defaultStyles.pdf
};

for (var _i = 0; _i < wordMimeTypes.length; _i++) {
  var type = wordMimeTypes[_i];
  mimeTypeToIconMap[type] = faFileWord;
  mimeTypeToFallBackStyle[type] = {
    type: 'document'
  };
}

for (var _i2 = 0; _i2 < excelMimeTypes.length; _i2++) {
  var _type = excelMimeTypes[_i2];
  mimeTypeToIconMap[_type] = faFileExcel;
  mimeTypeToFallBackStyle[_type] = {
    type: 'spreadsheet'
  };
}

for (var _i3 = 0; _i3 < powerpointMimeTypes.length; _i3++) {
  var _type2 = powerpointMimeTypes[_i3];
  mimeTypeToIconMap[_type2] = faFilePowerpoint;
  mimeTypeToFallBackStyle[_type2] = {
    type: 'presentation'
  };
}

for (var _i4 = 0; _i4 < archiveFileTypes.length; _i4++) {
  var _type3 = archiveFileTypes[_i4];
  mimeTypeToIconMap[_type3] = faFileArchive;
  mimeTypeToFallBackStyle[_type3] = {
    type: 'compressed'
  };
}

for (var _i5 = 0; _i5 < codeFileTypes.length; _i5++) {
  var _type4 = codeFileTypes[_i5];
  mimeTypeToIconMap[_type4] = faFileCode;
  mimeTypeToFallBackStyle[_type4] = {
    type: 'code'
  };
}

function mimeTypeToIcon(mimeType) {
  if (mimeType == null) {
    return faFile;
  }

  var icon = mimeTypeToIconMap[mimeType];

  if (icon) {
    return icon;
  }

  if (mimeType.startsWith('audio/')) {
    return faFileAudio;
  }

  if (mimeType.startsWith('video/')) {
    return faFileVideo;
  }

  if (mimeType.startsWith('image/')) {
    return faFileImage;
  }

  if (mimeType.startsWith('text/')) {
    return faFileAlt;
  }

  return faFile;
}

function mimeTypeToStyle(mimeType) {
  if (mimeType == null) {
    return {};
  }

  var style = mimeTypeToStyle[mimeType];

  if (style) {
    return style;
  }

  if (mimeType.startsWith('audio/')) {
    return {
      type: 'audio'
    };
  }

  if (mimeType.startsWith('video/')) {
    return {
      type: 'video'
    };
  }

  if (mimeType.startsWith('image/')) {
    return {
      type: 'image'
    };
  }

  if (mimeType.startsWith('text/')) {
    return {
      type: 'document'
    };
  }

  return {};
}

function fileExtension(filename) {
  var defaultReturn = {
    full: '',
    end: ''
  };

  if (filename == null) {
    return defaultReturn;
  } // source: https://stackoverflow.com/a/1203361/2570866


  var a = filename.split('.');

  if (a.length === 1 || a[0] === '' && a.length === 2) {
    return defaultReturn;
  }

  var lastExtension = a.pop().toLowerCase();

  if (a.length === 1 || a[0] === '' && a.length === 2) {
    return {
      end: lastExtension,
      full: lastExtension
    };
  }

  var secondToLastExtension = a.pop().toLowerCase();

  if (secondToLastExtension !== 'tar') {
    return {
      end: lastExtension,
      full: lastExtension
    };
  }

  return {
    full: secondToLastExtension + '.' + lastExtension,
    end: lastExtension
  };
}
/**
 * @example ./examples/FileIcon.md
 */


var FileIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FileIcon, _React$Component);

  function FileIcon() {
    _classCallCheck(this, FileIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(FileIcon).apply(this, arguments));
  }

  _createClass(FileIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          big = _this$props.big,
          filename = _this$props.filename,
          mimeType = _this$props.mimeType;

      if (big) {
        var extension = fileExtension(filename);
        var style = defaultStyles[extension.end];

        if (!style) {
          style = mimeTypeToStyle(style);
        }

        return createElement(BigFileIcon, _extends({
          extension: extension.full
        }, style, {
          size: size
        }));
      }

      return createElement(FontAwesomeIcon, {
        className: "rfu-file-icon--small",
        icon: mimeTypeToIcon(mimeType)
      });
    }
  }]);

  return FileIcon;
}(Component);

_defineProperty(FileIcon, "defaultProps", {
  big: false,
  size: 50
});

/**
 * Component is described here.
 *
 * @example ./examples/LoadingIndicator.md
 */
var LoadingIndicator =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(LoadingIndicator, _React$PureComponent);

  function LoadingIndicator() {
    _classCallCheck(this, LoadingIndicator);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingIndicator).apply(this, arguments));
  }

  _createClass(LoadingIndicator, [{
    key: "render",
    value: function render() {
      return createElement("div", {
        className: "rfu-loading-indicator__spinner",
        style: {
          margin: '0 auto',
          borderColor: this.props.backgroundColor ? this.props.backgroundColor : '',
          borderTopColor: this.props.color ? this.props.color : '',
          width: this.props.size ? this.props.size : '',
          height: this.props.size ? this.props.size : '',
          borderWidth: this.props.width ? this.props.width : ''
        }
      });
    }
  }]);

  return LoadingIndicator;
}(PureComponent);

_defineProperty(LoadingIndicator, "defaultProps", {
  size: 20,
  width: 2
});

/**
 * Component that displays files which are being uploaded
 *
 * @example ./examples/FilePreviewer.md
 */
var FilePreviewer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FilePreviewer, _React$Component);

  function FilePreviewer() {
    _classCallCheck(this, FilePreviewer);

    return _possibleConstructorReturn(this, _getPrototypeOf(FilePreviewer).apply(this, arguments));
  }

  _createClass(FilePreviewer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          uploads = _this$props.uploads,
          handleRemove = _this$props.handleRemove,
          handleRetry = _this$props.handleRetry;
      return React__default.createElement("div", {
        className: "rfu-file-previewer"
      }, React__default.createElement("ol", null, uploads && uploads.map(function (upload) {
        return React__default.createElement("li", {
          key: upload.id,
          className: "rfu-file-previewer__file ".concat(upload.state === 'uploading' ? 'rfu-file-previewer__file--uploading' : '', " ").concat(upload.state === 'failed' ? 'rfu-file-previewer__file--failed' : '')
        }, React__default.createElement(FileIcon, {
          mimeType: upload.file.type,
          filename: upload.file.name
        }), React__default.createElement("a", {
          href: upload.url,
          download: true
        }, upload.file.name, upload.state === 'failed' && React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
          className: "rfu-file-previewer__failed",
          onClick: handleRetry && function () {
            return handleRetry(upload.id);
          }
        }, "failed"), React__default.createElement("div", {
          className: "rfu-file-previewer__retry",
          onClick: handleRetry && function () {
            return handleRetry(upload.id);
          }
        }, "retry"))), React__default.createElement("span", {
          className: "rfu-file-previewer__close-button",
          onClick: handleRemove && function () {
            return handleRemove(upload.id);
          }
        }, "\u2718"), upload.state === 'uploading' && React__default.createElement("div", {
          className: "rfu-file-previewer__loading-indicator"
        }, React__default.createElement(LoadingIndicator, null)));
      })));
    }
  }]);

  return FilePreviewer;
}(React__default.Component);

/**
 * An icon of a paperclip, which is used as the default icon for FileUploadButton
 *
 * @example ./examples/AttachmentIcon.md
 */

var AttachmentIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AttachmentIcon, _React$PureComponent);

  function AttachmentIcon() {
    _classCallCheck(this, AttachmentIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(AttachmentIcon).apply(this, arguments));
  }

  _createClass(AttachmentIcon, [{
    key: "render",
    value: function render() {
      return createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "20",
        viewBox: "0 0 24 24"
      }, createElement("path", {
        d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
      }), createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }));
    }
  }]);

  return AttachmentIcon;
}(PureComponent);

/**
 * Component is described here.
 *
 * @example ./examples/FileUploadButton.md
 */
var FileUploadButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(FileUploadButton, _React$PureComponent);

  function FileUploadButton() {
    _classCallCheck(this, FileUploadButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(FileUploadButton).apply(this, arguments));
  }

  _createClass(FileUploadButton, [{
    key: "render",
    value: function render() {
      var _this = this;

      return createElement("div", {
        className: "rfu-file-upload-button"
      }, createElement("label", null, createElement("input", {
        type: "file",
        className: "rfu-file-input",
        onChange: function onChange(event) {
          _this.props.handleFiles(event.currentTarget.files);
        },
        multiple: this.props.multiple,
        disabled: this.props.disabled,
        accept: this.props.accepts && _typeof(this.props.accepts) === 'object' ? this.props.accepts.join(',') : this.props.accepts
      }), this.props.children));
    }
  }]);

  return FileUploadButton;
}(PureComponent);

_defineProperty(FileUploadButton, "defaultProps", {
  multiple: false,
  children: createElement(AttachmentIcon, null),
  disabled: false
});

function dataTransferItemsHaveFiles(items) {
  if (!items || !items.length) {
    return false;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (item.kind === 'file' || item.type === 'text/html') {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}
function dataTransferItemsToFiles(_x) {
  return _dataTransferItemsToFiles.apply(this, arguments);
}

function _dataTransferItemsToFiles() {
  _dataTransferItemsToFiles = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(items) {
    var fileLikes, blobPromises, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item, file, parser, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _loop, _iterator3, _step3;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!items || !items.length)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", []);

          case 2:
            fileLikes = [];
            blobPromises = [];
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context3.prev = 7;

            for (_iterator2 = items[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              item = _step2.value;

              if (item.kind === 'file') {
                file = item.getAsFile();

                if (file) {
                  fileLikes.push(file);
                }
              }
            } // If there are files inside the DataTransferItem prefer those


            _context3.next = 15;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](7);
            _didIteratorError2 = true;
            _iteratorError2 = _context3.t0;

          case 15:
            _context3.prev = 15;
            _context3.prev = 16;

            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }

          case 18:
            _context3.prev = 18;

            if (!_didIteratorError2) {
              _context3.next = 21;
              break;
            }

            throw _iteratorError2;

          case 21:
            return _context3.finish(18);

          case 22:
            return _context3.finish(15);

          case 23:
            if (!fileLikes.length) {
              _context3.next = 25;
              break;
            }

            return _context3.abrupt("return", fileLikes);

          case 25:
            // Otherwise extract images from html
            parser = new DOMParser();
            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _iteratorError3 = undefined;
            _context3.prev = 29;

            _loop = function _loop() {
              var item = _step3.value;

              if (item.type === 'text/html') {
                blobPromises.push(new Promise(function (accept) {
                  item.getAsString(
                  /*#__PURE__*/
                  function () {
                    var _ref = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee2(s) {
                      var doc, imageTags, imagePromises, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _loop2, _iterator4, _step4, _ret;

                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              doc = parser.parseFromString(s, 'text/html');
                              imageTags = doc.getElementsByTagName('img');
                              imagePromises = [];
                              _iteratorNormalCompletion4 = true;
                              _didIteratorError4 = false;
                              _iteratorError4 = undefined;
                              _context2.prev = 6;

                              _loop2 = function _loop2() {
                                var tag = _step4.value;

                                if (!tag.src) {
                                  return "continue";
                                }

                                imagePromises.push(_asyncToGenerator(
                                /*#__PURE__*/
                                _regeneratorRuntime.mark(function _callee() {
                                  var res, contentType, buf, blob;
                                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1) {
                                      switch (_context.prev = _context.next) {
                                        case 0:
                                          _context.prev = 0;
                                          _context.next = 3;
                                          return fetch(tag.src);

                                        case 3:
                                          res = _context.sent;
                                          _context.next = 9;
                                          break;

                                        case 6:
                                          _context.prev = 6;
                                          _context.t0 = _context["catch"](0);
                                          return _context.abrupt("return");

                                        case 9:
                                          contentType = res.headers.get('Content-type') || 'application/octet-stream';
                                          _context.next = 12;
                                          return res.arrayBuffer();

                                        case 12:
                                          buf = _context.sent;
                                          blob = new Blob([buf], {
                                            type: contentType
                                          });
                                          fileLikes.push(blob);

                                        case 15:
                                        case "end":
                                          return _context.stop();
                                      }
                                    }
                                  }, _callee, this, [[0, 6]]);
                                }))());
                              };

                              _iterator4 = imageTags[Symbol.iterator]();

                            case 9:
                              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                                _context2.next = 16;
                                break;
                              }

                              _ret = _loop2();

                              if (!(_ret === "continue")) {
                                _context2.next = 13;
                                break;
                              }

                              return _context2.abrupt("continue", 13);

                            case 13:
                              _iteratorNormalCompletion4 = true;
                              _context2.next = 9;
                              break;

                            case 16:
                              _context2.next = 22;
                              break;

                            case 18:
                              _context2.prev = 18;
                              _context2.t0 = _context2["catch"](6);
                              _didIteratorError4 = true;
                              _iteratorError4 = _context2.t0;

                            case 22:
                              _context2.prev = 22;
                              _context2.prev = 23;

                              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                              }

                            case 25:
                              _context2.prev = 25;

                              if (!_didIteratorError4) {
                                _context2.next = 28;
                                break;
                              }

                              throw _iteratorError4;

                            case 28:
                              return _context2.finish(25);

                            case 29:
                              return _context2.finish(22);

                            case 30:
                              _context2.next = 32;
                              return Promise.all(imagePromises);

                            case 32:
                              accept();

                            case 33:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2, this, [[6, 18, 22, 30], [23,, 25, 29]]);
                    }));

                    return function (_x2) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                }));
              }
            };

            for (_iterator3 = items[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              _loop();
            }

            _context3.next = 38;
            break;

          case 34:
            _context3.prev = 34;
            _context3.t1 = _context3["catch"](29);
            _didIteratorError3 = true;
            _iteratorError3 = _context3.t1;

          case 38:
            _context3.prev = 38;
            _context3.prev = 39;

            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }

          case 41:
            _context3.prev = 41;

            if (!_didIteratorError3) {
              _context3.next = 44;
              break;
            }

            throw _iteratorError3;

          case 44:
            return _context3.finish(41);

          case 45:
            return _context3.finish(38);

          case 46:
            _context3.next = 48;
            return Promise.all(blobPromises);

          case 48:
            return _context3.abrupt("return", fileLikes);

          case 49:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[7, 11, 15, 23], [16,, 18, 22], [29, 34, 38, 46], [39,, 41, 45]]);
  }));
  return _dataTransferItemsToFiles.apply(this, arguments);
}

var ImageDropzone =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ImageDropzone, _React$PureComponent);

  function ImageDropzone() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ImageDropzone);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ImageDropzone)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_handleFiles",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(accepted, rejected) {
        var handleFiles, fileLikes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                handleFiles = _this.props.handleFiles;

                if (handleFiles) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                if (!(accepted && accepted.length)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", handleFiles(accepted));

              case 5:
                _context.next = 7;
                return dataTransferItemsToFiles(rejected);

              case 7:
                fileLikes = _context.sent;

                if (!fileLikes.length) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", handleFiles(fileLikes));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(ImageDropzone, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleFiles = _this$props.handleFiles,
          children = _this$props.children;
      return createElement(Dropzone, {
        onDrop: handleFiles && this._handleFiles,
        disableClick: true,
        disablePreview: true //style={{position: 'absolute', height: '100%', width: '100%', zIndex: -1000000}}
        ,
        className: "rfu-dropzone",
        style: {
          position: 'relative'
        },
        accept: this.props.accept,
        multiple: this.props.multiple,
        disabled: this.props.disabled,
        acceptClassName: "rfu-dropzone--accept",
        rejectClassName: "rfu-dropzone--reject"
      }, createElement("div", {
        className: "rfu-dropzone__notifier",
        style: {}
      }, createElement("div", {
        className: "rfu-dropzone__inner"
      }, createElement("svg", {
        width: "41",
        height: "41",
        viewBox: "0 0 41 41",
        xmlns: "http://www.w3.org/2000/svg"
      }, createElement("path", {
        d: "M40.517 28.002V3.997c0-2.197-1.808-3.992-4.005-3.992H12.507a4.004 4.004 0 0 0-3.992 3.993v24.004a4.004 4.004 0 0 0 3.992 3.993h24.005c2.197 0 4.005-1.795 4.005-3.993zm-22.002-7.997l4.062 5.42 5.937-7.423 7.998 10H12.507l6.008-7.997zM.517 8.003V36c0 2.198 1.795 4.005 3.993 4.005h27.997V36H4.51V8.002H.517z",
        fill: "#000",
        fillRule: "nonzero"
      })), createElement("p", null, "Drag your files here to add to your post"))), children);
    }
  }]);

  return ImageDropzone;
}(PureComponent);

_defineProperty(ImageDropzone, "defaultProps", {
  multiple: true,
  disabled: false
});

/**
 * This is simply a button wrapper, add's a div with `role="button"` and a onClick
 * @example ./examples/IconButton.md
 */
var IconButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IconButton, _React$Component);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconButton).apply(this, arguments));
  }

  _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          children = _this$props.children;
      return createElement("div", {
        className: "rfu-icon-button",
        role: "button",
        onClick: onClick
      }, children);
    }
  }]);

  return IconButton;
}(Component);

var placeholder = "data:image/png;base64,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";

/**
 * Component is described here.
 *
 * @example ./examples/Thumbnail.md
 */
var Thumbnail =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Thumbnail, _React$PureComponent);

  function Thumbnail() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Thumbnail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Thumbnail)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_handleClose", function () {
      if (_this.props.handleClose) {
        _this.props.handleClose(_this.props.id);
      }
    });

    return _this;
  }

  _createClass(Thumbnail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          image = _this$props.image,
          handleClose = _this$props.handleClose,
          size = _this$props.size;
      var svg = '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M465 5c5.53 0 10 4.47 10 10s-4.47 10-10 10-10-4.47-10-10 4.47-10 10-10zm3.59 5L465 13.59 461.41 10 460 11.41l3.59 3.59-3.59 3.59 1.41 1.41 3.59-3.59 3.59 3.59 1.41-1.41-3.59-3.59 3.59-3.59-1.41-1.41z" id="b"/><filter x="-30%" y="-30%" width="160%" height="160%" filterUnits="objectBoundingBox" id="a"><feOffset in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowBlurOuter1"/></filter></defs><g transform="translate(-451 -1)" fill-rule="nonzero" fill="none"><use fill="#000" filter="url(#a)" xlink:href="#b"/><use fill="#FFF" fill-rule="evenodd" xlink:href="#b"/></g></svg>';
      return React__default.createElement("div", {
        className: "rfu-thumbnail__wrapper",
        style: {
          width: size,
          height: size
        }
      }, React__default.createElement("div", {
        className: "rfu-thumbnail__overlay"
      }, handleClose ? React__default.createElement(IconButton, {
        onClick: this._handleClose
      }, React__default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: svg
        }
      })) : null), React__default.createElement("img", {
        src: image,
        className: "rfu-thumbnail__image",
        alt: ""
      }));
    }
  }]);

  return Thumbnail;
}(React__default.PureComponent);

_defineProperty(Thumbnail, "defaultProps", {
  size: 100,
  image: placeholder
});

/**
 * An icon of a picture, which is used as the default icon for ImageUploadButton
 *
 * @example ./examples/PictureIcon.md
 */

var PictureIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PictureIcon, _React$PureComponent);

  function PictureIcon() {
    _classCallCheck(this, PictureIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(PictureIcon).apply(this, arguments));
  }

  _createClass(PictureIcon, [{
    key: "render",
    value: function render() {
      return createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
      }, createElement("path", {
        d: "M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm3 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM2 16v2h16v-6l-3-3-6 6-3-3-4 4z",
        fillRule: "nonzero"
      }));
    }
  }]);

  return PictureIcon;
}(PureComponent);

/**
 * Component is described here.
 *
 * @example ./examples/ImageUploadButton.md
 */
var ImageUploadButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ImageUploadButton, _React$PureComponent);

  function ImageUploadButton() {
    _classCallCheck(this, ImageUploadButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImageUploadButton).apply(this, arguments));
  }

  _createClass(ImageUploadButton, [{
    key: "render",
    value: function render() {
      var _this = this;

      return createElement("div", {
        className: "rfu-image-upload-button"
      }, createElement("label", null, createElement("input", {
        type: "file",
        className: "rfu-image-input",
        onChange: function onChange(event) {
          _this.props.handleFiles(event.currentTarget.files);
        },
        accept: "image/*",
        multiple: this.props.multiple,
        disabled: this.props.disabled
      }), this.props.children));
    }
  }]);

  return ImageUploadButton;
}(PureComponent);

_defineProperty(ImageUploadButton, "defaultProps", {
  multiple: false,
  disabled: false,
  children: createElement(PictureIcon, null)
});

/**
 * Component is described here.
 *
 * @example ./examples/ThumbnailPlaceholder.md
 */
var ThumbnailPlaceholder =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ThumbnailPlaceholder, _React$Component);

  function ThumbnailPlaceholder() {
    _classCallCheck(this, ThumbnailPlaceholder);

    return _possibleConstructorReturn(this, _getPrototypeOf(ThumbnailPlaceholder).apply(this, arguments));
  }

  _createClass(ThumbnailPlaceholder, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleFiles = _this$props.handleFiles,
          multiple = _this$props.multiple;
      return React__default.createElement(ImageUploadButton, {
        handleFiles: handleFiles,
        multiple: multiple
      }, React__default.createElement("div", {
        role: "button",
        className: "rfu-thumbnail-placeholder"
      }, React__default.createElement("svg", {
        width: "14",
        height: "15",
        viewBox: "0 0 14 15",
        xmlns: "http://www.w3.org/2000/svg"
      }, React__default.createElement("path", {
        d: "M14 8.998H8v6H6v-6H0v-2h6v-6h2v6h6z",
        fill: "#A0B2B8",
        fillRule: "nonzero"
      }))));
    }
  }]);

  return ThumbnailPlaceholder;
}(React__default.Component);

_defineProperty(ThumbnailPlaceholder, "defaultProps", {
  multiple: false
});

/**
 * Component is described here.
 *
 * @example ./examples/ImagePreviewer.md
 */
var ImagePreviewer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ImagePreviewer, _React$Component);

  function ImagePreviewer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ImagePreviewer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ImagePreviewer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_handleClose", function (id) {
      if (_this.props.handleRemove) {
        if (id == null) {
          console.warn("id of closed image was undefined, this shouldn't happen");
          return;
        }

        _this.props.handleRemove(id);
      }
    });

    return _this;
  }

  _createClass(ImagePreviewer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          imageUploads = _this$props.imageUploads,
          handleRemove = _this$props.handleRemove,
          handleRetry = _this$props.handleRetry,
          handleFiles = _this$props.handleFiles;
      return React__default.createElement("div", {
        className: "rfu-image-previewer"
      }, imageUploads && imageUploads.map(function (image) {
        return React__default.createElement("div", {
          key: image.id,
          className: "rfu-image-previewer__image".concat(image.state === 'finished' ? ' rfu-image-previewer__image--loaded' : '')
        }, image.state === 'failed' && React__default.createElement("div", {
          className: "rfu-image-previewer__retry",
          dangerouslySetInnerHTML: {
            __html: '<svg width="22" height="20" viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg"><path d="M20 5.535V2a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 0 1 0-2h3.638l-2.975-2.653a8 8 0 1 0 1.884 8.32 1 1 0 1 1 1.886.666A10 10 0 1 1 5.175 1.245c3.901-2.15 8.754-1.462 11.88 1.667L20 5.535z" fill="#FFF" fill-rule="nonzero"/></svg>'
          },
          onClick: handleRetry && function () {
            return handleRetry(image.id);
          }
        }), React__default.createElement(Thumbnail, {
          handleClose: handleRemove && _this2._handleClose,
          image: image.previewUri || image.url,
          id: image.id
        }), image.state === 'uploading' && React__default.createElement(LoadingIndicator, {
          backgroundColor: "rgba(255,255,255,0.1)",
          color: "rgba(255,255,255,0.7)"
        }));
      }), handleFiles && !this.props.disabled && React__default.createElement(ThumbnailPlaceholder, {
        handleFiles: handleFiles,
        multiple: this.props.multiple
      }));
    }
  }]);

  return ImagePreviewer;
}(React__default.Component);

_defineProperty(ImagePreviewer, "defaultProps", {
  multiple: true,
  disabled: false
});

export { FilePreviewer, FileUploadButton, ImageDropzone, ImagePreviewer, ImageUploadButton, FileIcon, AttachmentIcon, PictureIcon, Thumbnail, ThumbnailPlaceholder, LoadingIndicator, IconButton, dataTransferItemsToFiles, dataTransferItemsHaveFiles };
//# sourceMappingURL=index.es.js.map
